






import Vue from 'vue';
import SkillSim from '@/components/skill/skillsim/SkillSim.vue';
import { createNamespacedHelpers } from 'vuex';
import createSkillSimStore, { Actions, ISkillSimState } from '@/views/SkillSimStore';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('skillsim');

export default Vue.extend({
    components: { SkillSim },
    beforeCreate() {
        if (!this.$store.hasModule('skillsim')) {
            this.$store.registerModule('skillsim', createSkillSimStore());
        }  
    },
    mounted() {
        this.init(this.$route.query);
        this.setEmbedded(true);
    },
    beforeDestroy() {
        this.$store.unregisterModule('skillsim');
    },
    computed: {
        skillSimState(): ISkillSimState {
            return (this.$store.state as any).skillsim;
        },
    },
    methods: {
        ...mapActions({
            init: Actions.Init,
        }),
        ...mapMutations({
            setEmbedded: 'setEmbedded',
        }),
    },
})
